import { ConversationMonitoring } from "./conversationMonitoring";
import { NodeStatus } from "./nodeStatus";

type AssistantNode = {
  nodeId: string;
  nodeType: "assistant";
  name: string;
  description: string;
  settings: AssistantNodeSettings;
  status: NodeStatus;
};

type AssistantNodeSettings = {
  assistant: string;
  conversation?: string;
  monitoringSettings: ConversationMonitoring[];
  // fromNumber?: string;
};

const defaultAssistantNode = {
  nodeType: "assistant",
  settings: {
    description: "",
    name: "Assistant",
    assistant: "",
    // fromNumber: "",
    monitoringSettings: [],
  },
};

export { AssistantNode, AssistantNodeSettings, defaultAssistantNode };
